import { Pipe, PipeTransform } from '@angular/core'
import * as _ from 'lodash'

@Pipe({ name: 'table', standalone: false })
export class TablePipe implements PipeTransform {
  transform(table?: object[], singleLine = false) {
    const keys = Object.keys(table[0])
    if (table.length > 0) {
      const result = _.map(table, (val) => {
        return Object.values(val).join(' - ')
      })
      return keys.join(' - ') + '<br>' + result.join(singleLine ? ', ' : '<br>')
    } else {
      return ''
    }
  }
}
